import styled from 'styled-components';

import { Icon } from '@creditornot/alchemy-react';
import * as icons from '@creditornot/alchemy-react/icons';
import { color } from '@creditornot/cb-ingredients/design-tokens';

const Root = styled.div<{ $progressPercentage: number }>`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  height: 38px;
  width: 38px;
  background: conic-gradient(
    ${color.bgFillPositive} ${({ $progressPercentage }) => $progressPercentage}%,
    ${color.bgSurface} ${({ $progressPercentage }) => $progressPercentage}%
  );
`;

const InnerCircle = styled.div`
  background: ${color.bg};
  height: 30px;
  width: 30px;
  border-radius: 50%;
`;

type Props = {
  progressPercentage: number;
};

export const ProgressCircle = ({ progressPercentage }: Props) => {
  if (progressPercentage < 100) {
    return (
      <Root $progressPercentage={progressPercentage}>
        <InnerCircle />
      </Root>
    );
  }

  if (progressPercentage === 100) {
    return <Icon source={icons.checkmarkCircleFilled} size="medium" fill={color.textPositive} />;
  }

  return <Icon source={icons.alertFilled} size="medium" fill={color.textWarning} />;
};
